// extracted by mini-css-extract-plugin
export default {"dashboardGrid":"AuthenticationFirewallDashboard_dashboardGrid__dKjJE"};